<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm02">
<a id="page07">
<div class="chapterHead">
<h2 class="chapterTitle"><span class="bold"><em class="italic">Prologue</em></span></h2></div>
</a><div class="chapterBody"><a id="page07">
<p class="chapterOpenerText"><span class="chapterOpenerFirstLetters"><span class="bold">T</span></span>here was a man in the house. Again.</p>
<p class="para" style="text-indent: 1em">Sloan’s stomach got that funny, sick feeling like he was going to vomit. He hated when Mama brought someone home at night. Someone drunk and noisy. He knew what people said about her. Joni Hawkins was no good, like her jailbird husband. They gossiped, said dirty things about her. He was eleven. He wasn’t stupid. He knew what the words meant.</p>
<p class="para" style="text-indent: 1em">They were all big fat liars.</p>
<p class="para" style="text-indent: 1em">He tiptoed down the dark hallway to the door, careful not to be heard. Mama would tell him to go back to bed. But he worried when she brought a man home.</p>
<p class="para" style="text-indent: 1em">He could hear them in there, but he couldn’t make out the words. The man’s voice rumbled, rising at times. Then Mama’s soothing tones would calm him down. She was good at soothing.</p>
<p class="para" style="text-indent: 1em">A narrow beam of light sliced along the edge of the wooden floor. Breath held, he placed his right eye against the skinny crack and slowly, slowly let the air ease out through his nose.</p>
</a><p class="para" style="text-indent: 1em"><a id="page07">He couldn’t see much. A flash of Mama’s pink diner shirt. A man’s leg in dark pants. Dress-up pants. Sloan could </a><a id="page08">see a big hand, too, held out toward Mama as though asking for something.</a></p><a id="page08">
<p class="para" style="text-indent: 1em">What was that on the man’s wrist? A watch? Sloan squeezed closer until the wood pressed hard into his face and his eyelashes folded back against his eyelid. Not a watch, a fancy bracelet with stones. Sloan held back a laugh, relaxing a little. Only a sissy would wear a bracelet like a girl. Who was in there?</p>
<p class="para" style="text-indent: 1em">“Mama?” he said before he could stop the word.</p>
<p class="para" style="text-indent: 1em">The voices inside the room stilled. Footsteps moved toward him. The door cracked open the tiniest bit and Mama’s face appeared.</p>
<p class="para" style="text-indent: 1em">“What are you doing up, Sloan?”</p>
<p class="para" style="text-indent: 1em">“Who’s in there with you?”</p>
<p class="para" style="text-indent: 1em">“Nobody important. Go back to bed. You have school tomorrow.”</p>
<p class="para" style="text-indent: 1em">More curious now than worried, he made no effort to leave. Mama reached out and smoothed his hair. “On my next day off, we’ll go fishing. Just me and you. Okay?”</p>
<p class="para" style="text-indent: 1em">When he nodded, his mama smiled. Then she shut the door.</p>
<p class="para" style="text-indent: 1em">He never saw her again.</p>
</a></div><a id="page08">
</a></div>
<a id="page08">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// weddinggardenthe_fm02.vue?4b53d70b